module.exports = __webpack_public_path__ + "img/wall2-1.074d24b5.png";